import { useTranslation } from "react-i18next";

export default function Security() {
    const { t, i18n } = useTranslation();
    return (
        <div className="mt-12 mb-8">
            <div className="bg-white rounded-2xl p-8 shadow-2xl border border-gray-200">
                <div className="text-center">
                    <p className="text-xl md:text-2xl font-bold text-foreground mb-8">
                        {t("billing.learnMoreAboutSecurity")}{" "}
                        <a
                            href={`https://www.agentui.ai/${
                                i18n.language === "es" ? "es" : "en"
                            }/security/`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 hover:text-blue-700 underline font-bold"
                        >
                            https://www.agentui.ai/
                            {i18n.language === "es" ? "es" : "en"}
                            /security/
                        </a>
                    </p>

                    {/* Security Logos */}
                    <div className="flex items-center justify-center gap-8 mb-10 flex-wrap">
                        <img
                            src="https://www.agentui.ai/esof-shield.png"
                            alt="ESOF Shield"
                            className="h-24 md:h-32 object-contain"
                        />
                        <img
                            src="https://www.agentui.ai/soc2.png"
                            alt="SOC 2"
                            className="h-24 md:h-32 object-contain"
                        />
                        <div className="flex items-center gap-2 bg-green-50 border border-green-200 rounded-lg px-4 py-2">
                            <svg
                                className="w-5 h-5 text-green-600"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                            </svg>
                            <span className="text-green-700 font-semibold">
                                GDPR Compliant
                            </span>
                        </div>
                    </div>

                    {/* Security Features Checklist */}
                    <div className="space-y-4">
                        <h3 className="text-xl font-bold mb-6 text-center text-foreground">
                            {t("billing.securityFeatures")}
                        </h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="flex items-start gap-3 p-4 bg-gray-50 rounded-lg border border-gray-200">
                                <svg
                                    className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M5 13l4 4L19 7"
                                    />
                                </svg>
                                <span className="text-gray-700 font-medium">
                                    {t("billing.security.dataPrivacy")}
                                </span>
                            </div>
                            <div className="flex items-start gap-3 p-4 bg-gray-50 rounded-lg border border-gray-200">
                                <svg
                                    className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M5 13l4 4L19 7"
                                    />
                                </svg>
                                <span className="text-gray-700 font-medium">
                                    {t("billing.security.continuousMonitoring")}
                                </span>
                            </div>
                            <div className="flex items-start gap-3 p-4 bg-gray-50 rounded-lg border border-gray-200">
                                <svg
                                    className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M5 13l4 4L19 7"
                                    />
                                </svg>
                                <span className="text-gray-700 font-medium">
                                    {t("billing.security.secureInfrastructure")}
                                </span>
                            </div>
                            <div className="flex items-start gap-3 p-4 bg-gray-50 rounded-lg border border-gray-200">
                                <svg
                                    className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M5 13l4 4L19 7"
                                    />
                                </svg>
                                <span className="text-gray-700 font-medium">
                                    {t("billing.security.auditLogs")}
                                </span>
                            </div>
                            <div className="flex items-start gap-3 p-4 bg-gray-50 rounded-lg border border-gray-200 md:col-span-2">
                                <svg
                                    className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M5 13l4 4L19 7"
                                    />
                                </svg>
                                <span className="text-gray-700 font-medium">
                                    {t(
                                        "billing.security.encryptedAtRestAndTransit"
                                    )}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
